(function ($) {
  let menuWidth = 1024;

  let arrLeonardGTMTrackingFormPath = [
    '/contact-us/',
    '/fr/nous-contacter/',
    '/careers/apply/',
    '/fr/carrieres/appliquer/',
  ]

  let arrLeonardGTMTrackingAllProductsPath = [
    '/products/',
    '/fr/produits/',
  ]

  let arrLeonardGTMTrackingProductPath = [
    '/products/caskets/',
    '/funeral-tray/',
    '/fr/produits/cercueils/',
    '/fr/plateaux-funeraires/',
  ]

  $(document).ready(function () {
    initLeonardGTMTracking();

    $(window).on('resize', ccResize);

    $(document).on('click', '.cc-menu-open', ccOpenMenu);
    $(document).on('click', '.cc-main-menu.menu > li.menu-item-has-children > a', ccHeaderOpenSubMenu);

    if ($('.expertise-slider').length > 0) {
      $('.expertise-slider').not('.slick-initialized').slick({
        infinite: false,
        prevArrow: '<a class="slick-nav slick-prev"><span class="icon icon-arrow"></span></a>',
        nextArrow: '<a class="slick-nav slick-next"><span class="icon icon-arrow"></span></a>'
      });
    }

    if ($('.samples-slider').length > 0) {
      $('.samples-slider').not('.slick-initialized').slick({
        infinite: false,
        prevArrow: '<a class="slick-nav slick-prev"><span class="icon icon-arrow"></span></a>',
        nextArrow: '<a class="slick-nav slick-next"><span class="icon icon-arrow"></span></a>'
      });
    }

    if ($('.testimonials-slider').length > 0) {
      $('.testimonials-slider').not('.slick-initialized').slick({
        infinite: false,
        centerMode: true,
        centerPadding: '40',
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<a class="slick-nav slick-prev"><span class="icon icon-arrow"></span></a>',
        nextArrow: '<a class="slick-nav slick-next"><span class="icon icon-arrow"></span></a>'
      });
    }

    if ($('.btn-video').length > 0) {
      $('.btn-video').magnificPopup({
        type: 'iframe',
      });
    }

    if (jQuery('.filters-mobile').length > 0) {
      jQuery('.filters-mobile').on('click', function (event) {
        event.preventDefault();

        jQuery(this).parent().parent('.filters-container').toggleClass('sub-open');
      });
    }

    if ($('.single-jobs').length && $('#job_type').length) {
      $('#job_type').attr('value', $('.single-jobs h1').text());
    }
    document.addEventListener('wpcf7mailsent', contactFormRedirection, false);

    if ($('.images-viewer').length > 0) {
      let firstImageViewer = $(this).find('.image-thumbnail').first().html();

      $(this).find('.image-thumbnail').first().addClass('active-viewer');

      $('.image-viewer').empty().append(firstImageViewer);

      $('.image-thumbnail').on('click', ccChangeViewerImage);
    }

    // gdpr cookie popup
    // ----------
    var gdpr_cookie = getGDPRCookie("gdpr-agreement");

    if (gdpr_cookie == null) {
      $(".gdpr-agreement").removeClass("gdpr-hide");

      $(".gdpr-agreement > a").bind("click", function (e) {
        e.preventDefault();
        $(".gdpr-agreement").addClass("gdpr-hide");
        setGDPRCookie("gdpr-agreement", 1, 360);
      });
    }

    if ($('#reg_billing_country').length > 0) {
      $('#reg_billing_country').on('change', function () {
        let country = this.value;

        if (country == 'CA') {
          if ($('.state-ca').hasClass('hidden')) {
            $('.state-ca').removeClass('hidden');
          }
          if ($('.postal').hasClass('hidden')) {
            $('.postal').removeClass('hidden');
          }
          if (!$('.state-us').hasClass('hidden')) {
            $('.state-us').addClass('hidden');
          }
          if (!$('.zip').hasClass('hidden')) {
            $('.zip').addClass('hidden');
          }
        }
        else {
          if (!$('.state-ca').hasClass('hidden')) {
            $('.state-ca').addClass('hidden');
          }
          if (!$('.postal').hasClass('hidden')) {
            $('.postal').addClass('hidden');
          }
          if ($('.state-us').hasClass('hidden')) {
            $('.state-us').removeClass('hidden');
          }
          if ($('.zip').hasClass('hidden')) {
            $('.zip').removeClass('hidden');
          }
        }
      });
    }

    if($('.woocommerce .woocommerce-MyAccount-content .btn-yellow').length > 0) {
      $('.woocommerce .woocommerce-MyAccount-content .btn-yellow').on('click', function(e) {
        e.preventDefault();

        let file_name = $(this).closest('form').find('input[name="file_name"]').val();
        let file_type = $(this).closest('form').find('input[name="file_type"]').val();
        let client_number = $(this).closest('form').find('input[name="client_number"]').val();

        const tab = window.open('about:blank');

        $.ajax({
          type : "post",
          url : ajaxurl,
          data : {
            action: "cc_get_file_link",
            file_name : file_name,
            file_type : file_type,
            client_number: client_number,
            updated_viewed: 'true'
          },
          success: function(data) {
            tab.location = data;
            tab.focus();
          }
        }) 
      });
    }
  });

  function ccResize(e) {

    let winWidth = window.innerWidth;

    if (winWidth > menuWidth) {
      $('body').removeClass('cc-menu-opened');

      $('.cc-main-menu .sub-menu').removeClass('sub-menu-opened');
      $('.cc-main-menu > li > a').removeClass('cc-sub-menu-selected');

      $('.cc-menu-open').removeClass('cc-menu-close');
      $('.cc-menus-container').removeClass('cc-menu-opened');
    }
  }

  function ccOpenMenu() {
    $('body').toggleClass('cc-menu-opened')
    $('.cc-menus-container').toggleClass('cc-menu-opened');
    $('.cc-menu-open').toggleClass('cc-menu-close');
  }

  function ccHeaderOpenSubMenu(e) {
    if (window.innerWidth < menuWidth) {
      e.preventDefault();
      ccOpenSubMenu(this);
    }
  }

  function ccOpenSubMenu(el) {
    let allSubMenu = $(el).parent().parent().find('.sub-menu').not($(el).parent().find('.sub-menu'))
    let subMenuSelected = $(el).parent().find('.sub-menu');

    allSubMenu.removeClass('sub-menu-opened');
    subMenuSelected.toggleClass('sub-menu-opened');

    $(el).parent().parent().find('a').not($(el)).removeClass('cc-sub-menu-selected');
    $(el).toggleClass('cc-sub-menu-selected');
  }

  /**
   * Function called on the Contact Form 7 form submission.
   * Redirect to the page selected.
  **/
  function contactFormRedirection(event) {
    redirectUrl = $('input[name=redirect_url]').val();

    if (redirectUrl != undefined) {
      $.urlParam = function (name) {
        let results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.search);
        return (results !== null) ? results[1] || 0 : false;
      }

      let queryParam = $.urlParam('poste');
      let emailSent = $('#iEmail').val();

      if (queryParam) {
        window.location = redirectUrl + "?poste=" + queryParam + "&email=" + emailSent;
      }
      else {
        window.location = redirectUrl;
      }
    }
  }

  function initLeonardGTMTracking() {
    // Track CTA pointing to a «Leads Form»
    // -------
    let arrLeonardGTMTrackingCTA = [];
    let arrLeonardGTMTrackingAllProducts = [];
    let arrLeonardGTMTrackingProduct = [];

    for (let i = 0; i < arrLeonardGTMTrackingFormPath.length; i++) {
      arrLeonardGTMTrackingCTA.push("a.btn[href*='" + arrLeonardGTMTrackingFormPath[i] + "'], a.button[href*='" + arrLeonardGTMTrackingFormPath[i] + "']");
    }

    $(arrLeonardGTMTrackingCTA.join(", ")).addClass("gtm-form-view");

    // Custom CSS rules here
    for (let i = 0; i < arrLeonardGTMTrackingAllProductsPath.length; i++) {
      arrLeonardGTMTrackingAllProducts.push("a[href*='" + arrLeonardGTMTrackingAllProductsPath[i] + "']");
    }
    for (let i = 0; i < arrLeonardGTMTrackingProductPath.length; i++) {
      arrLeonardGTMTrackingProduct.push("a[href*='" + arrLeonardGTMTrackingProductPath[i] + "']");
    }

    $(arrLeonardGTMTrackingAllProducts.join(", ")).addClass("gtm-cta-1");
    $(arrLeonardGTMTrackingProduct.join(", ")).addClass("gtm-cta-2");
    $('.home a.btn').addClass("gtm-cta-3");

    // Track «Leads form» submit button click
    // -------
    if (arrLeonardGTMTrackingFormPath.indexOf(window.location.pathname) != -1) {
      if (!$("form button, form input[type=submit]").hasClass("gtm-form-submited")) {
        $("form button, form input[type=submit]").addClass("gtm-form-submited");
      }
    }
  }

  function ccChangeViewerImage() {
    let taxonomyContent = $(this).html();

    $('.image-thumbnail').removeClass('active-viewer');

    $(this).addClass('active-viewer');
    $(this).closest('.images-viewer').find('.image-viewer').empty().append(taxonomyContent);
  }

  // Set cookie information
  //
  // @return Void
  function setGDPRCookie(cookie_name, value, expiration_days) {
    var expiration_date = new Date();
    expiration_date.setDate(expiration_date.getDate() + expiration_days);

    var cookie_value = escape(value) + ((expiration_days == null) ? "" : "; expires=" + expiration_date.toUTCString()) + "; path=/";
    document.cookie = cookie_name + "=" + cookie_value;
  }

  // Get cookie information
  //
  // @return String || undefined
  function getGDPRCookie(cookie_name) {
    var cookie_value = document.cookie;
    var cookie_start = cookie_value.indexOf(" " + cookie_name + "=");

    if (cookie_start == -1) cookie_start = cookie_value.indexOf(cookie_name + "=");

    if (cookie_start == -1) {
      cookie_value = null;
    } else {
      cookie_start = cookie_value.indexOf("=", cookie_start) + 1;
      var c_end = cookie_value.indexOf(";", cookie_start);

      if (c_end == -1) c_end = cookie_value.length;

      cookie_value = unescape(cookie_value.substring(cookie_start, c_end));
    }

    return cookie_value;
  }
})(jQuery);